import React, { useState, useEffect } from 'react';
import { format, getDayOfYear, getWeek } from 'date-fns';
import moment from 'moment-hijri';
import { CalendarIcon, ClockIcon } from '@heroicons/react/24/outline';

const DateTimeWidget = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Gregorian date
  const gregorianDate = format(currentTime, 'EEEE, MMMM dd, yyyy');
  const time = format(currentTime, 'HH:mm:ss');
  const dayOfYear = getDayOfYear(currentTime);
  const weekOfYear = getWeek(currentTime);

  // Hijri date
  const hijriMoment = moment(currentTime);
  const hijriDate = hijriMoment.format('iYYYY/iMM/iDD');
  const hijriMonthYear = hijriMoment.format('iMMMM iYYYY');

  const hijriMonths = [
    'Muharram', 'Safar', 'Rabi al-Awwal', 'Rabi al-Thani',
    'Jumada al-Awwal', 'Jumada al-Thani', 'Rajab', 'Shaban',
    'Ramadan', 'Shawwal', 'Dhul-Qadah', 'Dhul-Hijjah'
  ];

  return (
    <div className="portal-widget h-full">
      <div className="portal-widget-header">
        <h3 className="portal-widget-title flex items-center">
          <ClockIcon className="h-5 w-5 mr-2" />
          Date & Time
        </h3>
      </div>

      <div className="space-y-6">
        {/* Current Time */}
        <div className="text-center">
          <div className="text-5xl font-bold theme-text-primary font-mono tracking-wider">
            {time}
          </div>
          <div className="mt-2 theme-text-secondary text-sm">
            {Intl.DateTimeFormat().resolvedOptions().timeZone}
          </div>
        </div>

        {/* Gregorian Calendar */}
        <div className="theme-bg-secondary rounded-lg p-4">
          <div className="flex items-center mb-2">
            <CalendarIcon className="h-4 w-4 theme-text-secondary mr-2" />
            <span className="text-xs theme-text-secondary font-semibold uppercase">
              Gregorian Calendar
            </span>
          </div>
          <div className="theme-text-primary font-medium">
            {gregorianDate}
          </div>
          <div className="mt-1 theme-text-tertiary text-sm">
            Day {dayOfYear} of {format(currentTime, 'yyyy')}
          </div>
        </div>

        {/* Hijri Calendar */}
        <div className="theme-bg-secondary rounded-lg p-4">
          <div className="flex items-center mb-2">
            <CalendarIcon className="h-4 w-4 theme-text-secondary mr-2" />
            <span className="text-xs theme-text-secondary font-semibold uppercase">
              Hijri Calendar (Islamic)
            </span>
          </div>
          <div className="theme-text-primary font-medium">
            {hijriDate}
          </div>
          <div className="mt-1 theme-text-tertiary text-sm">
            {hijriMonthYear}
          </div>
        </div>

        {/* Additional Info */}
        <div className="grid grid-cols-2 gap-4 text-center">
          <div className="theme-bg-secondary rounded-lg p-3">
            <div className="text-2xl font-bold theme-text-primary">
              {weekOfYear}
            </div>
            <div className="text-xs theme-text-secondary mt-1">
              Week of Year
            </div>
          </div>
          <div className="theme-bg-secondary rounded-lg p-3">
            <div className="text-2xl font-bold theme-text-primary">
              {dayOfYear}
            </div>
            <div className="text-xs theme-text-secondary mt-1">
              Day of Year
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateTimeWidget;
